// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import translate from "@insite/client-framework/Translate";

export enum CheckoutStepKey {
    addresses = "addresses",
    payment = "payment",
    review = "review",
}

export interface CheckoutStep {
    key: CheckoutStepKey;
    title: string;
    index: number;
    titleDisplay?: string;
    isDisabled?: boolean;
    onClickHandler?: () => void;
    validate: () => Promise<boolean>;
}

function createInitalCheckoutStep(key: CheckoutStepKey, title: string, icon?: React.FC): CheckoutStep {
    return {
        index: 0,
        key,
        title,
        validate: () => {
            return new Promise(resolve => resolve(true));
        },
    };
}

const addressesStep: CheckoutStep = createInitalCheckoutStep(CheckoutStepKey.addresses, translate("Addresses"));
const paymentStep: CheckoutStep = createInitalCheckoutStep(CheckoutStepKey.payment, translate("Payment"));
const reviewStep: CheckoutStep = createInitalCheckoutStep(CheckoutStepKey.review, translate("Review"));

const checkoutSteps: {
    [key: string]: CheckoutStep[];
} = {
    [FulfillmentMethod.PickUp]: [addressesStep, paymentStep, reviewStep],
    [FulfillmentMethod.Ship]: [addressesStep, paymentStep, reviewStep],
};

export const getCheckoutSteps = (FulfillmentMethod: string, isBuyer1?: boolean) => {
    const steps = checkoutSteps[FulfillmentMethod].filter(step => step.key !== CheckoutStepKey.payment || !isBuyer1);
    steps.every((step, i) => {
        step.index = i;
        step.titleDisplay = step.title;
        return true;
    });
    return steps;
};
